import $ from 'jquery';
import React,{useEffect,useState} from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useSearchParams,Link,useParams } from 'react-router-dom';

import {btnSetColor_CBack,CallMapMethod,RespBkMthdMapp,AjaxCallMethod,
    GetImgCertUser,sortListNew,TableDatePicker,CallMapMethod_CBack,setFilters,
    ajaxindicatorstop,ajaxindicatorstart} from '../function_lib/common_lib';
import {getRoleDetails,CallCMSMapMethod_CBack,pgIndexLimit,writeJSLib} from '../function_lib/common_cms';

import Front_Header from '../pages/front_header';
// import Footer from './footer';
import Comp_Sf_Footer from '../pages/comp_sf_footer';


import Article_Listing_n from '../sample_comp_v2/article_listing';
import {Home_Banner_n,Home_Banner2Div_n,Home_Banner_WithNews_n} from '../sample_comp_v2/home_banner';
import Article_Blogs_n from '../sample_comp_v2/article_blogs';
import Left_Img_Txt_Desc_n from '../sample_comp_v2/left_img_txt_desc';
import Single_Img_Msg_n from '../sample_comp_v2/single_img_msg';
import Txt_Description_n from '../sample_comp_v2/txt_description';
import ImageGallery_n from '../sample_comp_v2/image_gallery';
import Video_Slider_n from '../sample_comp_v2/video_slider';
import {Testimonials_n} from '../sample_comp_v2/testimonials';
import Image_Collarge_Grid_n from '../sample_comp_v2/image_collarge_grid';
import Text_Thumbnail_n from '../sample_comp_v2/text_thumbnail';
import Comp_Group_Page from '../sample_comp_v2/comp_group_page';
import {Collapse_Pan_n,Collapse_Pan_Images_n} from '../sample_comp_v2/collapse_pan';
import Card_List from '../sample_comp_v2/card_list';
import Comp_Ashtech_Main_Banner from '../sample_comp_v2/comp_ashtech_main_banner';

import Blog_Listing_New from '../sample_comp_v2/blog_listing_new';

import Product_Slider from '../sample_comp_v2/product_slider';

import Account_Opt_Link from './account_opt_link';
import Comp_Candidate_Card from '../comp_weds/comp_candidate_card';
import Comp_Member_Filters from '../comp_weds/comp_member_filters';
import Comp_Popup_Profile_Viewer from '../comp_weds/comp_popeup_profile_viewer';
//import Member_Dashboard from './member_dashboard';


import '../pages/contact_us.css';

export const Search_Matching=()=>{
    const location = useLocation();
    let checkLoadJs=0;
   
     const [loc,setLoc]=useState('');
    const [stPgData,setStPgData]=useState([]);
    const [_pgIndexed,setPgIndexed]=useState([]);

    const [useJSList,setJsList]=useState(0);


    // member page stacks
    const [stGotraList,setGotraList]=useState([]);
    const [stMembersList,setMembersList]=useState([]);

    const [logInObj,setLoginObj]=useState([]);
    const [stProfileView,setProfileView]=useState({});

    const [stStates,setStates]=useState([]);

    let _searchParams={};

    const getStates=()=>{
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getStates"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getStates";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setStates(jsList);
            }
        })
    }

    const serSearchParams=(searchParams)=>{
        _searchParams=searchParams;
        //   alert(JSON.stringify(searchParams));
        //   return;
        getMemberDetails();
        
    }

    const setProfileViewData=(item,reqStatus="")=>{
        //alert(reqStatus);
        setProfileView(item);
    }

    const sendMemberRequest=(sentAccId)=>{
        let pMap=[];
        pMap.push({name:"curl_type",value:"sendMemberRequest"});
        pMap.push({name:"res_func",value:"callBackpgDataNew"});
        pMap.push({name:"local_token",value:logInObj[0]["id"]});
        pMap.push({name:"req_acc_infoid",value:btoa(sentAccId)});

        //pMap.push({name:"ser_params",value:JSON.stringify(_searchParams)});
        pMap["res_func"]="callBackpgDataNew";
        pMap["curl_type"]="sendMemberRequest";
        CallMapMethod_CBack(this,pMap,function(data,msg){
            //alert(data);
            if(data==="001"){
                alert("Request send to member, you can view profile once member will accept your request");
                getMemberDetails();

            }
        })    

    }

    const getMemberDetails=()=>{
        //alert("i m in lcik "+JSON.stringify(logInObj));
        //alert(JSON.stringify(_searchParams));
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getMembers"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        pgMap.push({name:"local_token",value:JSON.parse(localStorage.getItem("userDS"))[0]["id"]});
        pgMap.push({name:"ser_params",value:JSON.stringify(_searchParams)});
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getMembers";
        ajaxindicatorstart();
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            ajaxindicatorstop();
            // alert(data);
            if(data!=="0"){
                // alert(data);
                let jsList=JSON.parse(data);
                setMembersList(jsList);
                
            }
        })
    }

    const getGotraList=()=>{
        
        let pgMap=[];
        pgMap.push({name:"curl_type",value:"getGotraList"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"only_cms",value:"d"});
        
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getGotraList";
        CallMapMethod_CBack(this,pgMap,function(data,msg){
            //alert("GoutraList"+data);
            if(data!=="0"){
                let jsList=JSON.parse(data);
                setGotraList(jsList);
            }
        })
    }

    //contact request --
   const addMemeberReq=()=>{
    // alert("Thanks for your Registration, Out team will contact soon, for the verification process.");
    // window.location.reload();
        btnSetColor_CBack(this,"member-form","register_member",function(data,msg){
          // alert(msg);
            if(data==="-10" || data===-10){
                alert(msg);
            }else if(data!=="0"){
                alert("Thanks for your Registration, Our team will contact soon for the verification process...");
                window.location.reload();
            }
        })
    }

    // CMS data calling
    const getCMSData=(_loc)=>{
        
        //alert(_loc);
        var pgMap=[];
        pgMap.push({name:"curl_type",value:"getPgData"});
        pgMap.push({name:"res_func",value:"callBackpgDataNew"});
        pgMap.push({name:"loc",value:_loc});
        pgMap.push({name:"only_cms",value:"d"});
        
       
        pgMap["res_func"]="callBackpgDataNew";
        pgMap["curl_type"]="getPgData";
        CallCMSMapMethod_CBack(this,pgMap,function(data,msg){
            //alert(data);
            let listObj=JSON.parse(data);
            setStPgData(listObj.access);
            if(listObj.length>0){
                
            }

            if(useJSList===0 && checkLoadJs===0)
                {
                    checkLoadJs=1;
                    setJsList(1);
                writeJSLib();
                setFilters();
            }

            AjaxCallMethod(this,"okSuccCNOT");
        });
        
    }

    
    useEffect(()=>{
        if(localStorage.getItem("userDS")!=null){
            setLoginObj(JSON.parse(localStorage.getItem("userDS")))
        }
    },[stMembersList]);

    useEffect(()=>{
        setPgIndexed(pgIndexLimit());
        getGotraList();
        getStates();
        
        //alert(location["pathname"].substr(1));
        //setLocation(useLocation());
        //setLoc();
        let _loc=location["pathname"].substr(1);
        if(_loc===""){
            _loc="home";
        }
        setLoc(_loc);
        //alert(loc);
        getCMSData(_loc);

        if(localStorage.getItem("userDS")!=null){
            setLoginObj(JSON.parse(localStorage.getItem("userDS")))
        }
        
    },[])
    useEffect(()=>{
       if(stGotraList.length>0){
        getMemberDetails();
       // setFilters();
       }
        
    },[stGotraList])

return(<>
 
    {/* <!-- Navbar & Carousel End --> */}

<Front_Header loc={loc}/>
    {/* add cms componet */}
    {_pgIndexed.map((item_m,mi)=>{
       // alert(mi+"=== "+_pgIndexed.length);
        if(mi===_pgIndexed.length-1){
         //  alert("i m in set state");
          // setJsList(1);
       }
                if(mi===6){
                    if(typeof stPgData[mi]!=="undefined"){
                        //alert(JSON.stringify(this.state.stPgData[mi]));
                    }
                    
                }
return(<>{typeof stPgData[mi]!=="undefined"?<>
    {/*not in use <Home_Banner_n/> */}
    
    {typeof stPgData[mi]["home_banner"]!=="undefined"?<Home_Banner_WithNews_n lsData={stPgData[mi]["home_banner"]} />:''}
    {typeof stPgData[mi]["home_banner2div"]!=="undefined"?<Home_Banner2Div_n lsData={stPgData[mi]["home_banner2div"]} />:''}
    {typeof stPgData[mi]["list_slider"]!=="undefined"?<Article_Blogs_n lsData={stPgData[mi]["list_slider"]} />:''}

    {typeof stPgData[mi]["card_list"]!=="undefined"?<Card_List lsData={stPgData[mi]["card_list"]} />:''}
    
    {typeof stPgData[mi]["img_text_desc_img_left"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_left"]} />:''}
    {typeof stPgData[mi]["img_text_desc_img_right"]!=="undefined"?<Left_Img_Txt_Desc_n lsData={stPgData[mi]["img_text_desc_img_right"]} img_right="true" />:''}
    
    {typeof stPgData[mi]["image_collarge_grid"]!=="undefined"?<Image_Collarge_Grid_n lsData={stPgData[mi]["image_collarge_grid"]} />:''}
    {typeof stPgData[mi]["video_slider"]!=="undefined"?<Video_Slider_n lsData={stPgData[mi]["video_slider"]} />:''}

    {typeof stPgData[mi]["text_thumbnail"]!=="undefined"?<Text_Thumbnail_n lsData={stPgData[mi]["text_thumbnail"]} />:''}

    {typeof stPgData[mi]["text_description"]!=="undefined"?<Txt_Description_n lsData={stPgData[mi]["text_description"]} />:''}

    {typeof stPgData[mi]["article_listing"]!=="undefined"?<Article_Listing_n isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["article_listing"]} />:''}

    {typeof stPgData[mi]["blog_listing"]!=="undefined"?<Blog_Listing_New isSort={loc==="e_news"?true:false} sortparam={["entry_date",false,"date"]} lsData={stPgData[mi]["blog_listing"]} />:''}

    {typeof stPgData[mi]["single_img_text"]!=="undefined"?<Single_Img_Msg_n lsData={stPgData[mi]["single_img_text"]} />:''}

    {typeof stPgData[mi]["image_gallery"]!=="undefined"?<ImageGallery_n lsData={stPgData[mi]["image_gallery"]} />:''}

    {typeof stPgData[mi]["collapse_pan"]!=="undefined"?<Collapse_Pan_Images_n lsData={stPgData[mi]["collapse_pan"]}/>:''}
    
    {typeof stPgData[mi]["testimonials"]!=="undefined"?<Testimonials_n lsData={stPgData[mi]["testimonials"]}/>:''}
    
    
    </>:''}</>);
   
        })
        }
        {/* end of cms part */}

        <div className="container container-fluid px-1 py-5 mx-auto">
       
            <Account_Opt_Link/>
               
                {/* <div className="card dia_cart border-box-3"> */}
                <div class="container text-start">
                    <div class="row">
                        
<div class="mobile-filter-button">
    <a href="javascript:void(0)" class="btn btn-warning open_filters filter-button">
        <i class="fa fa-search my-float">Search</i>
    </a>
</div>
                        <Comp_Member_Filters pStateList={stStates} pGautraList={stGotraList} onRunSearch={serSearchParams}/>
                        <div className="col-lg-9 d-flex flex-column gap-2">
            <div id="resps_search_candi"></div>
 {/* dashboard component */}
 {stMembersList.map((item,index)=>{
       return (<Comp_Candidate_Card sendReq={sendMemberRequest} onViewProfile={setProfileViewData} member={item} />)
    })}

    {/* end of dashboard compnent */}

            </div>
                    </div>
    {/* <h2 class="text-center mb-4">Welcome {logInObj.length>0?logInObj[0]["first_name"]:''}</h2> */}
   
   
</div>

                </div>
           
        {/* </div> */}
        <Comp_Popup_Profile_Viewer profileData={stProfileView}/>
        {/* <Footer/> */}
        <Comp_Sf_Footer/>

</>)
}
export default Search_Matching;